module.exports = __webpack_public_path__ + "media/images/social-share-button/pinterest-c4efa3d87652218d2fd6e7a6541ec2c3.svg";